<template>
  <Modal title="添加补升订单" v-model="editModal" width="700">
    <Form ref="form" class="form" :label-width="100" label-position="left"
          :model="formData" :rules="formRule">
      <Row>
        <i-col :span="11" :offset="1">
          <Form-item label="订单类型" prop="channel">
            <Select v-model.number="formData.channel" filterable clearable transfer>
              <Option v-for="item in $constant.orderChannelRenew"
                      :value="item.code" :key="item.code">{{ item.text }}
              </Option>
            </Select>
          </Form-item>
        </i-col>
        <i-col :span="11">
          <Form-item label="学生ID" prop="uid">
            <Input v-model.number="formData.uid" placeholder="必填" @on-blur="inputMobile"/>
          </Form-item>
        </i-col>
      </Row>
      <Row v-if="formData.channel === 1">
        <i-col :span="11" :offset="1">
          <Form-item label="转介绍学生Id" prop="inviteId">
            <Input v-model.number="formData.inviteId" placeholder="必填"/>
          </Form-item>
        </i-col>
        <i-col :span="11">
          <Form-item label="转介绍凭证" prop="url">
            <multiple-image-upload :num="200" :defaultFileList="defaultPicList" v-model="formData.url"
                                   on-file-change="onFileChange"/>
          </Form-item>
        </i-col>
      </Row>
      <Row>
        <i-col :span="11" :offset="1">
          <Form-item label="学生姓名" prop="contractName">
            <Input v-model="formData.contractName" placeholder="选填"/>
          </Form-item>
        </i-col>
        <i-col :span="11" :offset="1">
          <Form-item label="外教课时" prop="num">
            <Input v-model.number="formData.num" placeholder="必填" v-on:input="calculateLeaveNum"></Input>
          </Form-item>
        </i-col>
<!--        <i-col :span="11" :offset="1">-->
<!--          <Form-item label="中教课时" prop="chineseNum">-->
<!--            <Input v-model.number="formData.chineseNum" placeholder="必填"></Input>-->
<!--          </Form-item>-->
<!--        </i-col>-->
<!--        <i-col :span="11" :offset="1">-->
<!--          <Form-item label="直播课时" prop="livingNum">-->
<!--            <Input v-model.number="formData.livingNum" placeholder="必填"/>-->
<!--          </Form-item>-->
<!--        </i-col>-->
        <!--        <i-col :span="11" :offset="1">-->
        <!--          <Form-item label="外教辅修课时" prop="minorNum">-->
        <!--            <Input v-model.number="formData.minorNum" placeholder="必填"></Input>-->
        <!--          </Form-item>-->
        <!--        </i-col>-->
        <!--        <i-col :span="11" :offset="1">-->
        <!--          <Form-item label="陪练课课时" prop="partnerNum">-->
        <!--            <Input v-model.number="formData.partnerNum" placeholder="必填"></Input>-->
        <!--          </Form-item>-->
        <!--        </i-col>-->
      </Row>
      <Row>
<!--        <i-col :span="11" :offset="1">-->
<!--          <Form-item label="课时优惠类型" prop="discountType" transfer>-->
<!--            <Select v-model="formData.discountType" @on-change="onDiscountTypeChange" transfer>-->
<!--              <Option v-for="item in discountTypeList"-->
<!--                      :value="item.value" :key="item.value">{{ item.label }}-->
<!--              </Option>-->
<!--            </Select>-->
<!--          </Form-item>-->
<!--        </i-col>-->
        <i-col :span="11" :offset="1" >
          <Form-item label="课程类型：" prop="tchChannel">
            <Select v-model="formData.tchChannel" transfer>
              <Option v-for="item in $constant.tchChannel"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </i-col>
        <i-col :span="11" :offset="1" >
          <Form-item label="赠送课时" prop="discountNum">
            <Input v-model.number="formData.discountNum" placeholder="赠送课时数"
                   v-on:input="calculateLeaveNum"></Input>
          </Form-item>
        </i-col>
      </Row>
      <Row>

<!--        <i-col :span="11" :offset="1">-->
<!--          <Form-item label="优惠金额" prop="discount">-->
<!--            <Input v-model.number="formData.discount" placeholder="优惠金额" v-on:input="calculatePayAmount"></Input>-->
<!--          </Form-item>-->
<!--        </i-col>-->
<!--        <i-col :span="23" :offset="1">-->
<!--          <Form-item label="优惠说明" prop="discountRemark">-->
<!--            <Input v-model.number="formData.discountRemark" placeholder="有优惠时必填"></Input>-->
<!--          </Form-item>-->
<!--        </i-col>-->
<!--        <i-col :span="11" :offset="1">-->
<!--          <Form-item label="订单原价" prop="amount">-->
<!--            <Input v-model.number="formData.amount" placeholder="必填" v-on:input="calculatePayAmount"></Input>-->
<!--          </Form-item>-->
<!--        </i-col>-->
        <i-col :span="11" :offset="1">
          <Form-item label="应付金额" prop="payAmount">
            <Input v-model.number="formData.payAmount" placeholder="必填"></Input>
          </Form-item>
        </i-col>
<!--        <i-col :span="11" :offset="1">-->
<!--          <Form-item label="收款公司" prop="payCompany">-->
<!--            <Select v-model="formData.payCompany" transfer>-->
<!--              <Option :value="10">邦德尔(销售)</Option>-->
<!--              <Option :value="11">虹兴达(学导)</Option>-->
<!--            </Select>-->
<!--          </Form-item>-->
<!--        </i-col>-->
<!--        <i-col :span="20" :offset="1">-->
<!--          <Form-item label="是否分笔：">-->
<!--            <Checkbox v-model="formData.hasTwoPay">分笔付款</Checkbox>-->
<!--          </Form-item>-->
<!--        </i-col>-->
<!--        <i-col :span="5" :offset="1" v-if="formData.hasTwoPay == true">-->
<!--          <InputNumber :max="3" :min="2" v-model.number="formData.twoPayNum" @on-change="zero"></InputNumber>-->
<!--        </i-col>-->
<!--        <i-col :span="5" v-if="formData.hasTwoPay == true">-->
<!--          <Form-item label="首笔款:" prop="firstPay" :label-width="55">-->
<!--            <Input v-model.number="formData.firstPay" placeholder="不得少于1000" @on-change="calculate"></Input>-->
<!--          </Form-item>-->
<!--        </i-col>-->
<!--        <i-col :span="5" :offset="1" v-if="formData.twoPayNum == 3">-->
<!--          <Form-item label="二笔款:" prop="secondPay" :label-width="55">-->
<!--            <Input v-model.number="formData.secondPay" placeholder="不得少于1000" @on-change="calculate"></Input>-->
<!--          </Form-item>-->
<!--        </i-col>-->
<!--        <i-col :span="5" :offset="1" v-if="formData.hasTwoPay == true">-->
<!--          <Form-item label="尾款:" :label-width="55">-->
<!--            <Input v-model.number="formData.lastPay" disabled></Input>-->
<!--          </Form-item>-->
<!--        </i-col>-->

<!--        <i-col :span="11" :offset="1" v-if="formData.tchChannel === 1">-->
<!--          <Form-item label="请假次数" prop="leaveNum">-->
<!--            <Input v-model.number="formData.leaveNum" placeholder="必填" disabled />-->
<!--          </Form-item>-->
<!--        </i-col>-->
        <i-col :span="11" :offset="1" v-if="formData.tchChannel === 2">
          <Form-item label="抵消课机会" prop="leaveNum">
            <Input v-model.number="formData.leaveNum" placeholder="必填" />
          </Form-item>
        </i-col>
<!--        <i-col :span="20" :offset="1" v-if="formData.tchChannel === 1" disabled>-->
<!--          <Form-item label="补课次数">-->
<!--            <Input v-model.number="formData.makeupLessonNum" placeholder="必填"   style="width: 207px"/>-->
<!--          </Form-item>-->
<!--        </i-col>-->
        <i-col :span="20" :offset="1" v-if="formData.tchChannel === 2">
          <Form-item label="24小时内取消课机会">
            <Input v-model.number="formData.makeupLessonNum" placeholder="必填"   style="width: 207px"/>
          </Form-item>
        </i-col>
<!--        <i-col :span="11" :offset="1">-->
<!--          <Form-item label="需要发票" prop="needInvoice">-->
<!--            <Select v-model="formData.needInvoice" transfer>-->
<!--              <Option value="0">否</Option>-->
<!--              <Option value="1">是</Option>-->
<!--            </Select>-->
<!--          </Form-item>-->
<!--        </i-col>-->
<!--        <i-col :span="11" :offset="1">-->
<!--          <Form-item label="需要合同" prop="needContract" transfer>-->
<!--            <Select v-model="formData.needContract" transfer>-->
<!--              <Option value="0">否</Option>-->
<!--              <Option value="1">是</Option>-->
<!--            </Select>-->
<!--          </Form-item>-->
<!--        </i-col>-->
<!--        <i-col :span="11" :offset="1">-->
<!--          <Form-item label="代理订单" prop="agentOrder" transfer>-->
<!--            <Select v-model="formData.agentOrder" transfer>-->
<!--              <Option value="0">否</Option>-->
<!--              <Option value="1">是</Option>-->
<!--            </Select>-->
<!--          </Form-item>-->
<!--        </i-col>-->
<!--        <i-col :span="11" :offset="1" v-if="formData.needInvoice==1">-->
<!--          <Form-item label="发票信息" prop="invoiceDetail">-->
<!--            <Input v-model="formData.invoiceDetail" type="textarea" :autosize="{minRows: 2,maxRows: 4}"/>-->
<!--          </Form-item>-->
<!--        </i-col>-->
<!--        <i-col :span="16" :offset="1">-->
<!--          <Form-item label="配送教材" prop="bookMaterialLevel" transfer>-->
<!--            <Select v-model="formData.bookMaterialLevel" placement="top" filterable clearable multiple transfer>-->
<!--              <Option v-for="item in materialPrice" :value="item.id" :key="item.id">{{ item.title }}</Option>-->
<!--            </Select>-->
<!--          </Form-item>-->
<!--        </i-col>-->
<!--        <i-col :span="22" :offset="1">-->
<!--          <Form-item label="邮寄地址" prop="address">-->
<!--            <Input v-model="formData.address" type="textarea" :autosize="{minRows: 2,maxRows: 4}" placeholder="选填"/>-->
<!--          </Form-item>-->
<!--        </i-col>-->

      </Row>
      <Row>
        <i-col :span="20" :offset="1" >
          <Form-item label="关联订单号：" prop="orgOrderId">
            <Select v-model="formData.orgOrderId" transfer>
              <Option v-for="item in orderList"
                      :value="item.orderId" :key="item.orderId">订单号：{{ item.orderId }} | 课时：{{ item.num }}</Option>
            </Select>
          </Form-item>
        </i-col>
        <i-col :span="22" :offset="1">
          <Form-item label="编辑合同" prop="contractVersionId">
            <Select v-model="formData.contractVersionId" @on-change="onChangeSelectContractVersion"  placement="top" filterable>
              <Option v-for="item in versionList" :value="item.id" :key="item.id">{{ item.title}}</Option>
            </Select>
          </Form-item>
        </i-col>
      </Row>
      <Row>
        <i-col :span="11" :offset="1" v-if="showDealMonth">
          <Form-item label="成交月份" prop="dealMonth">
            <Select v-model="formData.dealMonth" placeholder="请选择成交月份" transfer>
              <Option v-for="item in dealMonthOptions"
                      :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </Form-item>
        </i-col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="onClose">取消</Button>
      <Button type="primary" size="large" :loading="loading" @click="onInsert">保存</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'AddOtherOrderModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    return {
      loading: false,
      discountTypeList: [
        {
          value: 1,
          label: '课时赠送'
        },
        {
          value: 2,
          label: '现金减免'
        },
//          {
//            value: 4,
//            label: '课时赠送及现金减免'
//          },
        {
          value: 3,
          label: '不参与活动'
        }
      ],
      materialPrice: [],
      orderList: [],
      versionList: [],
      showDealMonth: false,
      dealMonthOptions: [
        {
          value: 1,
          label: '上月'
        },
        {
          value: 0,
          label: '本月'
        }
      ],
      isAdviser: false,
      isAgent: null,
      formData: {
        uid: null,
        mobile: null,
        amount: null,
        payAmount: null,
        courseType: null,
        discountType: null,
        tchChannel: 1,
        discountNum: 0,
        discount: 0,
        discountRemark: null,
        bookMaterialLevel: [],
        leaveNum: null,
        makeupLessonNum: null,
        minorNum: 0,
        partnerNum: 0,
        address: null,
        contractName: null,
        desc: null,
        num: null,
        livingNum: null,
        chineseNum: null,
        needInvoice: '0',
        needContract: '0',
        invoiceDetail: '',
        hasTwoPay: false,
        twoPayNum: 2,
        firstPay: 0,
        secondPay: 0,
        lastPay: 0,
        channel: null,
        inviteId: null,
        url: '',
        dealMonth: null,
        payCompany: 11
      },
      formRule: {}
    }
  },
  computed: {
    editModal: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.onClose()
      }
    }
  },
  methods: {
    inputMobile () {
      let self = this
      let uid = self.formData.uid
      if (uid) {
        // 查询手机号 + 是否代理渠道（补升无套餐下拉，硬校验在后端）
        self.$http.get('/agentInvite/queryByUid', {params: {'uid': uid, 'orgOrderList': 1}}).then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.formData.inviteId = res.data.inviteId
          self.formData.contractName = res.data.userNickname
          self.orderList = res.data.orderList
          if (typeof res.data.isAgent === 'boolean') {
            self.isAgent = res.data.isAgent
          } else {
            self.isAgent = null
          }
        })
      } else {
        self.isAgent = null
      }
    },
    onFileChange (fileList) {
      this.defaultPicList = fileList
    },
    queryContract () {
      let self = this
      self.$http.post('/common/contractSelect?type=1', {
        pageSize: 1000,
        pageIndex: 1,
      }).then(function (res) {
        if (res && res.data) {
          self.versionList = res.data.data
        }
      })
    },
    setDefaultPayCompany () {
      // 根据 adviserInfo 设置默认收款公司
      if (this.isAdviser) {
        this.formData.payCompany = '11'
      } else {
        this.formData.channel = 8
        this.formData.payCompany = '11'
      }
    },
    onInsert () {
      let self = this
      // 动态设置验证规则
      self.formRule = {
        uid: [
          {type: 'integer', required: true, message: '学生 ID 不能为空', trigger: 'blur'}
        ],
        payAmount: [
          {type: 'number', required: true, message: '不能为空', trigger: 'blur'}
        ],
        discountNum: [
          {type: 'integer', required: true, message: '不能为空', trigger: 'blur'}
        ],
        contractName: [
          {type: 'string', required: true, message: '不能为空', trigger: 'blur'}
        ],
        num: [
          {type: 'number', required: true, message: '不能为空', trigger: 'blur'}
        ],
        channel: [
          {type: 'number', required: true, message: '不能为空', trigger: 'blur'}
        ]
      }

      self.loading = true
      self.$refs.form.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loading = false
          return
        }
        if (self.formData.channel === 1 && self.formData.url === '') {
          self.$Message.warning('请上传转介绍凭证!')
          self.loading = false
          return
        }
        self.formData.amount = self.formData.payAmount
        self.$http.post('/fundPackage/insertOther', self.formData).then(res => {
          if (res && res.status === 'ok') {
            self.$Message.success('提交成功!')
            self.successCallback()
            self.onClose()
            self.onSuccess()
          }
          if (res && res.status === '505') {
            self.formData.dealMonth = 1
            self.showDealMonth = true
            // 添加 dealMonth 的必填验证规则
            self.formRule = {
              ...self.formRule,
              dealMonth: [
                {type: 'number', required: true, message: '成交月份不能为空', trigger: 'blur'}
              ]
            }
            self.$Message.warning('请选择成交月份')
          }
          self.loading = false
        })
      })
    },
    onDiscountTypeChange (val) {
      if (val === 1) {
        this.formData.discountNum = null
        this.formData.discount = 0
      } else if (val === 2) {
        this.formData.discountNum = 0
        this.formData.discount = null
      } else if (val === 3) {
        this.formData.discountNum = 0
        this.formData.discount = 0
      } else if (val === 4) {
        this.formData.discountNum = null
        this.formData.discount = null
      }
      this.calculatePayAmount()
    },
    calculatePayAmount () {
      this.zero()
      if (this.formData.amount) {
        if (this.formData.discount) {
          this.formData.payAmount = (this.formData.amount - this.formData.discount).toFixed(2)
        } else {
          this.formData.payAmount = this.formData.amount
        }
      }
    },
    calculateLeaveNum () {
      if (this.formData.num) {
        if (this.formData.discountNum) {
          this.formData.leaveNum = Math.floor((this.formData.num + this.formData.discountNum) / 40)
          this.formData.makeupLessonNum = Math.floor((this.formData.num + this.formData.discountNum) / 10)
        } else {
          this.formData.leaveNum = Math.floor(this.formData.num / 40)
          this.formData.makeupLessonNum = Math.floor(this.formData.num / 10)
        }
      }
    },
    zero () {
      this.formData.firstPay = 0
      this.formData.secondPay = 0
      this.formData.lastPay = 0
    },
    calculate () {
      if (this.formData.twoPayNum === 2) {
        this.formData.lastPay = this.formData.payAmount - this.formData.firstPay
      } else if (this.formData.twoPayNum === 3) {
        this.formData.lastPay = this.formData.payAmount - (this.formData.firstPay + this.formData.secondPay)
      }
    },
    onClose () {
      this.$emit('on-close')
    },
    onSuccess () {
      this.$emit('on-success')
    },
    resetDealMonthField () {
      this.showDealMonth = false
      this.formData.dealMonth = null
      // 清空验证规则
      this.formRule = {}
    }
  },
  created () {
    // 页面加载时判断当前用户是否为销售顾问
    this.isAdviser = !!this.$store.get('adviserInfo')
  },
  watch: {
    editModal (val) {
      if (val === false) {
        this.formData.needInvoice = '0'
        this.formData.needContract = '0'
      }
    },
    value (val) {
      let self = this
      if (val === true) {
        self.isAgent = null
        self.$http.get('/materialPrice/list').then(function (res) {
          if (res.data) {
            self.materialPrice = res.data
          }
        })
        self.queryContract()
        self.setDefaultPayCompany()
        this.formData.hasTwoPay = false
        this.formData.twoPayNum = 2
        this.formData.firstPay = 0
        this.formData.secondPay = 0
        this.formData.lastPay = 0
        this.formData.dealMonth = null
        self.resetDealMonthField()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AddOtherOrderModal.vue?0dd91709